/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

import { ActivityEventsPropertyFilter } from './activityEventsPropertyFilter.zod'
import { WidgetDateRange } from './widgetDateRange.zod'
import { WidgetFilterEntry } from './widgetFilterEntry.zod'

export const activityEventsListWidgetConfigLimitDefault = 25
export const activityEventsListWidgetConfigLimitMax = 50

export const activityEventsListWidgetConfigPropertiesOneMax = 20

export const ActivityEventsListWidgetConfig = /* @__PURE__ */ zod.object({
    dateRange: zod.union([WidgetDateRange, zod.null()]).optional(),
    filterTestAccounts: zod.union([zod.boolean(), zod.null()]).optional(),
    widgetFilters: zod.union([zod.record(zod.string(), WidgetFilterEntry), zod.null()]).optional(),
    limit: zod
        .number()
        .min(1)
        .max(activityEventsListWidgetConfigLimitMax)
        .default(activityEventsListWidgetConfigLimitDefault)
        .describe('Maximum number of events to return.'),
    eventName: zod
        .union([zod.string().min(1), zod.null()])
        .optional()
        .describe('Limit the feed to a single event name. Omit or null for all events.'),
    properties: zod
        .union([
            zod.array(ActivityEventsPropertyFilter).max(activityEventsListWidgetConfigPropertiesOneMax),
            zod.null(),
        ])
        .optional()
        .describe('Event and person property filters, matching Activity > Explore events.'),
})

export type ActivityEventsListWidgetConfig = zod.input<typeof ActivityEventsListWidgetConfig>
export type ActivityEventsListWidgetConfigOutput = zod.output<typeof ActivityEventsListWidgetConfig>
